const deletedCardsGroupsReducer = (data = [], action) => {
    switch(action.type){
        case 'DELETED_CARDSGROUPS':
            data = action.data
            return  [...data];
        default:
            return data;
    }
}

export default deletedCardsGroupsReducer;